import LocalEvaluateRequest from "../../../../mode/local/LocalEvaluateRequest"
import RemoteConfigEvaluateRequest from "../../RemoteConfigEvaluateRequest"
import { HackleUser, MatchValueType, RemoteConfigParameterConfig } from "../../../../../model/model"
import WorkspaceConfig from "../../../../../workspace/config/WorkspaceConfig"

export default class RemoteConfigLocalEvaluateRequest implements LocalEvaluateRequest, RemoteConfigEvaluateRequest {
  private constructor(
    readonly workspace: WorkspaceConfig,
    readonly entity: RemoteConfigParameterConfig,
    readonly user: HackleUser,
    readonly record: boolean,
    readonly requiredType: MatchValueType
  ) {}

  toString(): string {
    return `RemoteConfigLocalEvaluateRequest(key=${this.entity.key})`
  }

  static of(
    workspace: WorkspaceConfig,
    user: HackleUser,
    parameter: RemoteConfigParameterConfig,
    requiredType: MatchValueType,
    record = true
  ): RemoteConfigLocalEvaluateRequest {
    return new RemoteConfigLocalEvaluateRequest(workspace, parameter, user, record, requiredType)
  }
}
